var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
var SearchPresenter = /** @class */ (function () {
    function SearchPresenter(usecase, actions, useCasesStream) {
        this.usecase = usecase;
        this.actions = actions;
        this.useCasesStream = useCasesStream;
    }
    SearchPresenter.prototype.getTrending = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.trendingSearch.execute({
                            onSuccess: function (data) {
                                if (req.trendingAssetType && data) {
                                    data.type = req.trendingAssetType;
                                }
                                resolve(data);
                            },
                            onError: function (error) { return reject(error); },
                        }, req);
                    })];
            });
        });
    };
    SearchPresenter.prototype.saveTrending = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.saveTrendingSearch.execute({
                            onSuccess: function (data) { return resolve(data); },
                            onError: function (error) { return reject(error); },
                        }, req);
                    })];
            });
        });
    };
    SearchPresenter.prototype.allAssetTrending = function () {
        return __awaiter(this, void 0, void 0, function () {
            var trendingData, promiseData, data;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        trendingData = Object.entries(SearchAssetTypeEnum).map(function (_a) {
                            var _b = __read(_a, 2), keys = _b[0], values = _b[1];
                            return _this.getTrending({
                                trendingAssetType: values,
                            });
                        });
                        return [4 /*yield*/, Promise.all(trendingData)];
                    case 1:
                        promiseData = _b.sent();
                        data = (_a = {},
                            _a[SearchAssetTypeEnum.Equity] = [],
                            _a[SearchAssetTypeEnum.Future] = [],
                            _a[SearchAssetTypeEnum.Option] = [],
                            _a[SearchAssetTypeEnum.MF] = [],
                            _a[SearchAssetTypeEnum.PrimaryMarket] = [],
                            _a[SearchAssetTypeEnum.CurFut] = [],
                            _a[SearchAssetTypeEnum.CurOpt] = [],
                            _a[SearchAssetTypeEnum.ETFs] = [],
                            _a[SearchAssetTypeEnum.Indices] = [],
                            _a[SearchAssetTypeEnum.NcdSecondary] = [],
                            // [SearchAssetTypeEnum.SGB]: [],
                            // [SearchAssetTypeEnum.CORPFD]: [],
                            _a[SearchAssetTypeEnum.ComFut] = [],
                            _a[SearchAssetTypeEnum.ComOpt] = [],
                            _a);
                        promiseData
                            .filter(function (x) { return x; })
                            .map(function (x) {
                            data[x.type] = !!(x === null || x === void 0 ? void 0 : x.trending) ? x.trending : [];
                        });
                        return [2 /*return*/, data];
                }
            });
        });
    };
    SearchPresenter.prototype.getOptionChainToolData = function (req) {
        var _this = this;
        this.actions.optionChainToolActions.hideError();
        this.actions.optionChainToolActions.loader();
        return new Promise(function (resolve, reject) {
            _this.usecase.optionChainTool.execute({
                onSuccess: function (data) {
                    if (data) {
                        _this.actions.optionChainToolActions.getOptionChainToolData(data);
                    }
                    _this.actions.optionChainToolActions.stopLoader();
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.optionChainToolActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    _this.actions.optionChainToolActions.stopLoader();
                    reject(error);
                },
            }, req);
        });
    };
    SearchPresenter.prototype.getGeneralSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.genSearch.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    SearchPresenter.prototype.getAssetTypeSearch = function (type, req) {
        var _this = this;
        req.pageSize = 20;
        return new Promise(function (resolve, reject) {
            _this.usecase.assetSearch[type].execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    SearchPresenter.prototype.getFaqSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.faqSearch.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    SearchPresenter.prototype.getSearchedStreamData = function (subscribe, symbols, callBack) {
        var streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
        ];
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, callBack, symbols, streamMapKey, StreamingSectionName.SEARCH);
    };
    SearchPresenter.prototype.deleteRecentList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deleteRecent.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    SearchPresenter.prototype.putAllRecentList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.putAllRecent.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    return SearchPresenter;
}());
export default SearchPresenter;
